module.exports = __webpack_public_path__ + "img/5_of_Spades.svg.7e41c861.png";